module.exports = __webpack_public_path__ + "img/close.dbbe5cff.svg";